export enum DiscountType {
    Percentage = 'percentage',
    FixedAmount = 'fixed-amount'
}
